import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'

import Header from '../shared/components/Header';
import { Link } from "react-router-dom";
import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import InputField from "../shared/components/InputField";
import { useNavigate } from "react-router-dom";
import validator from 'validator'
import Alert from '../shared/Utils/AlertBox';
import Loader from '../shared/components/Loader';
import { useSearchParams } from "react-router-dom";


export default function ForgetPassword() {

    const [inputValue, setInputValue] = useState({ email: "", password: "", confirm_password: "" });
    const { email, password, confirm_password } = inputValue;
    const [terms, setTerms] = useState(false);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    let [requestId, setRequestId] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue((prev) => ({ ...prev, [name]: value, }));
    };


    useEffect(() => {
        if (searchParams.get("id") == null)
            setRequestId(0)
        else
            setRequestId(searchParams.get("id"))

    })

    function forgetPasswordRequest(e) {

        e.preventDefault();
        if (!validator.isEmail(email)) {
            return Alert.show('Error', 'Please enter the valid email', 'error')
        }

        let arr = [];
        let requestData = new FormData();

        arr.push({ P_Email: email });

        let p = SerializeClass.getSerializedData(arr);

        requestData.append('Params', p);

        let url = '/api/user/forgetPasswordRequest';
        setLoader(true)
        HttpCall.postRequest(url, requestData).then(response => {
            setLoader(false)
            if (response.data.code == 200) {
                Alert.show("Success!", "A password reset link has been sent to your email. Please check your email for instructions on how to reset your password", "success");
            } else {
                Alert.show("Error!", response.data.msg, "error");
            }
        }).catch(err => {
            console.log(err);
            setLoader(false)
        })
    }

    function resetPassword(e) {

        e.preventDefault();

        if (password.length < 5) {
            Alert.show("Error!", "Password length must be atleast 5 characters", "error");
            return;
        }

        if (password != confirm_password) {
            Alert.show("Error!", "Passwords did not match", "error");
            return;
        }

        let arr = [];
        let requestData = new FormData();

        arr.push({ P_Id: requestId });
        arr.push({ P_Password: password });

        let p = SerializeClass.getSerializedData(arr);

        requestData.append('Params', p);

        let url = '/api/user/resetPassword';
        setLoader(true)
        HttpCall.postRequest(url, requestData).then(response => {
            setLoader(false)
            if (response.data.code == 200) {
                Alert.show("Success!", "Password changed successfully.", "success");
                navigate('/');
            } else {
                Alert.show("Error!", response.data.msg, "error");
            }
        }).catch(err => {
            console.log(err);
            setLoader(false)
        })
    }

    return (
        <>
            <Header />
            {loader && <Loader />}
            <div className="basic-1 margin-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            {requestId == 0 && <div className="text-container no-margin-top">
                                <h2>Forgotten Password ?</h2>
                                <p>Enter your email to reset your password:</p>
                                <br></br>
                                <div className="form-container">
                                    <form id="requestForm" data-toggle="validator" data-focus="false">
                                        <InputField
                                            type="text"
                                            value={email}
                                            placeholder=""
                                            label="Email"
                                            name="email"
                                            onChange={handleChange}
                                        />
                                        <div className="form-group">
                                            <button type="submit" className="form-control-submit-button"
                                                onClick={forgetPasswordRequest}>REQUEST</button>
                                        </div>
                                        <div className="form-message">
                                            <div id="rmsgSubmit" className="h3 text-center hidden"></div>
                                        </div>
                                    </form>
                                </div>
                                <div className="signupbtn">
                                    <Link to="/" className="turquoise">Already have an account?</Link>
                                </div>
                            </div>}

                            {requestId != 0 && <div className="text-container no-margin-top">
                                <h2>Reset Password</h2>
                                <div className="form-container">
                                    <form id="requestForm" data-toggle="validator" data-focus="false">
                                        <InputField
                                            type="password"
                                            value={password}
                                            placeholder=""
                                            label="Password"
                                            name="password"
                                            onChange={handleChange}
                                        />

                                        <InputField
                                            type="password"
                                            value={confirm_password}
                                            placeholder=""
                                            label="Confirm Password"
                                            name="confirm_password"
                                            onChange={handleChange}
                                        />
                                        <div className="form-group">
                                            <button type="submit" className="form-control-submit-button"
                                                onClick={resetPassword}>RESET PASSWORD</button>
                                        </div>
                                        <div className="form-message">
                                            <div id="rmsgSubmit" className="h3 text-center hidden"></div>
                                        </div>
                                    </form>
                                </div>
                                <div className="signupbtn">
                                    <Link to="/" className="turquoise">Already have an account?</Link>
                                </div>
                            </div>}
                        </div>
                        <div className="col-lg-6">
                            <div className="image-container">
                                <img className="img-fluid" src={process.env.PUBLIC_URL + 'assets/images/details-1-office-worker.svg'} alt="alternative" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="copyright">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <p class="p-small">Copyright © 2023 <a href="https://getbound.ai/">Getbound.ai</a> - All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}